import React from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module'
import { Provider } from 'react-redux';

import { App } from './components';
import store from './store';

// const tagManagerArgs = {
//     gtmId: 'GTM-KW63F7F'
// }
//
// TagManager.initialize(tagManagerArgs)

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.querySelector('#root')
);
